import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { customerSubscriptionExpired } from 'src/data/customer';
import { getCustomerPlan, isPlanFromEnterpriseCategory } from 'src/data/subscription';
import { parseDateTime } from 'src/lib/format';
import { useHistory } from 'src/lib/hooks/useHistory';
import { ROUTES } from 'src/routes';
import { useCurrentCustomer } from 'src/store';
import { useInviteAcceptPopup } from 'src/views/InviteSubmitPopup';

import useViewState from './useViewState';

const RootPage = () => {
  const history = useHistory();
  const location = useLocation();

  const currentCustomer = useCurrentCustomer();
  const { currentUser, currentUserLoading } = useViewState();

  const showInviteAcceptModalIfNeeded = useInviteAcceptPopup();

  useEffect(() => {
    if (currentUserLoading) {
      return;
    }

    // Navigate to 'email verification' page if needed
    if (currentUser && !currentUser.isConfirmed) {
      history.replace(ROUTES.NOT_VERIFIED);
      return;
    }

    // Check if customer is allowed to use the Platform
    if (!currentCustomer || customerSubscriptionExpired(currentCustomer)) {
      return;
    }

    showInviteAcceptModalIfNeeded();

    // Navigate to dashboard/projects by default
    const homeRoute = getHomeRoute(currentCustomer);
    history.replace(`${homeRoute}${location.search}`);
  }, [
    currentUser,
    currentUserLoading,
    currentCustomer,
    history,
    showInviteAcceptModalIfNeeded,
    location.search,
  ]);

  return null;
};

export default RootPage;

const getHomeRoute = (customer) => {
  const plan = getCustomerPlan(customer);
  if (!isPlanFromEnterpriseCategory(plan) && isFreshCustomer(customer)) {
    return ROUTES.DASHBOARD;
  }

  return ROUTES.PROJECTS;
};

const isFreshCustomer = (customer) => {
  const date = parseDateTime(customer.createdAt);
  return date.isValid && Math.abs(date.diffNow('days').days) <= 30;
};
